export default {
  noDataToCompare: 'Keine Charge zum Vergleichen ausgewählt.',
};
